import React from "react";
import Icon from "../common/Icon";
import Tooltip from "./Tooltip";
import "./SerpFeatureIcons.css";

const FEATURE_LABELS = {
  organic: "Résultat organique",
  generative_trigger: "AIOverviews",
  related_search: "Recherches associées",
  people_also_ask: "People Also Ask",
  shopping: "Shopping",
  image: "Image",
  image_pack: "Pack images",
  images: "Images",
  video: "Vidéo",
  videos: "Vidéos",
  local_pack: "Pack local",
  place: "Lieu",
  knowledge_panel: "Knowledge Panel",
  knowledge_graph: "Knowledge Graph",
  news: "Actualités",
  featured_snippet: "Featured Snippet",
  twitter: "Twitter / X",
  top_stories: "Top Stories",
  jobs: "Offres d'emploi",
  recipes: "Recettes",
  flights: "Vols",
  hotels: "Hôtels",
  sports: "Sports",
  maps: "Maps",
  scholarly_articles: "Articles académiques",
  podcast: "Podcast",
  apps: "Applications",
  books: "Livres",
  finance: "Finance",
  events: "Événements",
};

const FEATURE_ICONS = {
  organic: "FileText",
  related_search: "Search",
  people_also_ask: "MessageCircleQuestion",
  shopping: "ShoppingCart",
  image: "Image",
  image_pack: "Images",
  images: "Image",
  video: "Video",
  videos: "Film",
  local_pack: "MapPin",
  place: "Building2",
  knowledge_panel: "Info",
  knowledge_graph: "Network",
  news: "Newspaper",
  featured_snippet: "Award",
  twitter: "Twitter",
  top_stories: "TrendingUp",
  jobs: "Briefcase",
  recipes: "Utensils",
  flights: "Plane",
  hotels: "Hotel",
  sports: "Trophy",
  maps: "Map",
  scholarly_articles: "GraduationCap",
  podcast: "Mic",
  apps: "Smartphone",
  books: "BookOpen",
  finance: "DollarSign",
  events: "Calendar",
};

const FALLBACK_ICON = "Sparkles";

export const getFeatureLabel = (type) =>
  FEATURE_LABELS[type] || type.replace(/_/g, " ").replace(/\b\w/g, (c) => c.toUpperCase());

export const getFeatureIcon = (type) => FEATURE_ICONS[type] || FALLBACK_ICON;

const SerpFeatureIcons = ({ features = [], size = 16 }) => {
  if (!features || features.length === 0) {
    return <span className="serp-features-empty">-</span>;
  }

  return (
    <div className="serp-features-list">
      {features.map((feature) => (
        <Tooltip key={feature} text={getFeatureLabel(feature)} position="top" delay={200}>
          <span className="serp-feature-icon" data-feature={feature}>
            <Icon name={getFeatureIcon(feature)} size={size} />
          </span>
        </Tooltip>
      ))}
    </div>
  );
};

export default SerpFeatureIcons;
